export default "__VITE_ASSET__9f6c88ea__"